const dataTableData = {
  columns: [
    { Header: "#", accessor: "index", width: "10%" },
    { Header: "اسم الموظف", accessor: "name", width: "15%" },
    { Header: "الحالة", accessor: "status", width: "10%" },
    { Header: "القسم", accessor: "departmentName", width: "15%" },
    { Header: "المنصب", accessor: "positionName", width: "13%" },
    { Header: "البريد الإلكتروني", accessor: "email", width: "14%" },
    { Header: "رقم الهاتف", accessor: "phone", width: "14%" },
    { Header: "اجراء", accessor: "actions", width: "15%" },
  ],

  rows: [], // Will be populated with API data
};

export default dataTableData;
